import { render, staticRenderFns } from "./manageUser.vue?vue&type=template&id=2a2f535e&scoped=true"
import script from "./manageUser.vue?vue&type=script&lang=ts"
export * from "./manageUser.vue?vue&type=script&lang=ts"
import style0 from "./manageUser.vue?vue&type=style&index=0&id=2a2f535e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f535e",
  null
  
)

export default component.exports